import { Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { CourseHighlights } from '../../model/my-team-elearning'
import { AppCarousel } from 'src/component/common/analog/molecule/carousel/AppCarousel'
import { CourseListPresentationItem } from 'src/feature/e-learning/component/organism/CourseListPresentationItem'
import { TeamLearningHighlightChartChart } from '../molecules/TeamLearningHighlightChart'
import { AppSkeleton } from 'src/component/common/analog/molecule/AppSkelton'

export type TeamLearningHighlightProps = {
  courseHighlights: CourseHighlights
  isLoading?: boolean
  highlightDisplayName: string
}

export const TeamLearningHighlight = observer((
  { courseHighlights, isLoading, highlightDisplayName }: TeamLearningHighlightProps,
) => {
  return (
    <AppBox sx={styles.root}>
      <Typography variant="h4">{highlightDisplayName}</Typography>
      <AppBox
        flexDirection={{ xs: 'column', md: 'column', lg: 'row' }}
        justifyContent="space-between"
        gap={10}
        width="100%"
      >
        <AppBox width={{ xs: '100%', md: '100%', lg: '60%' }}>
          {!isLoading && courseHighlights.courseInfo && courseHighlights.courseInfo.length > 0 && (
            <AppCarousel showDots={false} showProgressBar={false}>
              {courseHighlights.courseInfo.map(c => (
                <CourseListPresentationItem item={c} key={c.id} />
              ))}
            </AppCarousel>
          )}
        </AppBox>
        <AppBox width={{ xs: '100%', md: '100%', lg: '40%' }}>
          {!isLoading && courseHighlights.highlightChart && courseHighlights.highlightChart.length > 0 && (
            <TeamLearningHighlightChartChart highlightChart={courseHighlights.highlightChart} />
          )}
        </AppBox>
      </AppBox>
      {isLoading && (
        <>
          <AppSkeleton
            count={1}
            direction="column"
            rects={[{ width: '30%', height: 32 }]}
          />
          <AppSkeleton
            count={2}
            direction="row"
            rects={[{ width: '100%', height: 180 }]}
          />
        </>
      )}
    </AppBox>
  )
})

const styles = {
  root: {
    flexDirection: 'column',
    gap: 5,
  },
}
